import { AnyAction } from "redux";
import { SET_USER_GROUPS_LOADED } from "../actions/loadingUserGroups";

export const loadingUserGroups = (state = false, action: AnyAction) => {
  switch (action.type) {
    case SET_USER_GROUPS_LOADED:
      return action.userGroupsLoaded;
    default:
      return state;
  }
};

export default loadingUserGroups;
